import { FIELD_LIMITS } from '@/constants/fieldLimits'

export function fieldLimitError(label: string, max: number): string {
  return `${label} cannot exceed ${max} characters.`
}

export function validateStringLength(
  value: string,
  max: number,
  label: string,
): string | null {
  if (value.length > max) return fieldLimitError(label, max)
  return null
}

export function validateFieldLimits(
  checks: ReadonlyArray<{ value: string; max: number; label: string }>,
): string | null {
  for (const check of checks) {
    const err = validateStringLength(check.value, check.max, check.label)
    if (err) return err
  }
  return null
}

export function clampPageSize(size: number): number {
  const max = FIELD_LIMITS.pagination.pageSize
  if (!Number.isFinite(size) || size < 1) return 1
  return Math.min(Math.floor(size), max)
}

export function sanitizeDigitsOnly(value: string, maxLength?: number): string {
  const digits = value.replace(/\D/g, '')
  if (maxLength == null) return digits
  return digits.slice(0, maxLength)
}
